<template>
  <div>
    <div v-if="audio" class="background-img">
      <div class="background">
        <img class="disk" :class="{ isPlay: isPlay }" :src="diskImg" />
        <img class="pause" v-show="!isPlay" :src="pauseImg" />
        <img class="playing" v-show="isPlay" :src="playingImg" />
      </div>
    </div>
    <video id="video-js" class="video-js" controls>
      <source :src="src" />
    </video>
  </div>
</template>

<script>
export default {
  name: "gaia-player2",
  props: {
    src: {
      type: String,
      default: "",
    },
    audio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myPlayer: null,
      diskImg: null,
      pauseImg: null,
      playingImg: null,
      isPlay: false,
    };
  },
  mounted() {
    const that = this;
    let options = {
      autoplay: true, //自动播放
      language: "zh-CN",
      controls: true, //控制条
      preload: "auto", //自动加载
      errorDisplay: true, //错误展示
      textTrackDisplay: false, // 不渲染字幕相关DOM
      notSupportedMessage: "此视频暂无法播放，请稍后再试",
      hls: {
        overrideNative: true,
      },
      html5: {
        nativeAudioTracks: false,
        nativeVideoTracks: false,
      },
      type: "application/x-mpegURL",
    };
    this.myPlayer = videojs("video-js", options, function onPlayerReady() {
      this.on("ended", () => {
        that.ended();
      });
      this.on("playing", () => {
        that.playing();
      });
      this.on("pause", () => {
        that.pause();
      });
      this.on("waiting", () => {
        that.waiting();
      });
    });
    window.myPlayer = this.myPlayer;
    if (this.audio) {
      this.diskImg = require("@/assets/images/disk.png");
      this.pauseImg = require("@/assets/images/pause.png");
      this.playingImg = require("@/assets/images/playing.png");
    }
  },
  methods: {
    ended() {
      this.isPlay = false;
      console.log("视频播放结束");
      this.$emit("end");
    },
    playing() {
      this.isPlay = true;
      console.log("playing");
    },
    pause() {
      this.isPlay = false;
      console.log("pause");
    },
    waiting() {
      this.isPlay = false;
      console.log("waiting");
    },
  },
};
</script>

<style lang="less" scoped>
@height: 600px;
.main {
  width: 100%;
  position: relative;
  height: @height;
  max-height: @height;
  overflow: hidden;
}
.background-img {
  height: 0;
  .background {
    position: relative;
    top: 0;
    width: 900px;
    height: 506px;
    background: #d7d8dc;
    z-index: 1;
    img {
      position: relative;
      top: 0;
      z-index: 2;
    }
    @keyframes rotation {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .isPlay {
      animation: rotation 6s linear infinite;
      -webkit-animation: rotation 6s linear infinite;
      animation-fill-mode: forwards;
    }
    .disk {
      left: 25%;
    }
    .pause,
    .playing {
      left: 0;
    }
  }
}
</style>
<style lang="less">
@height: 450px;

// 播放器控件的一些设置
.video-js {
  width: 100% !important;
  height: @height !important;
  .vjs_video_3-dimensions {
    width: 100%;
    height: @height;
  }
  video::-webkit-media-controls {
    display: none !important;
  }
  .vjs-big-play-button {
    display: none;
  }
  .vjs-control-bar {
    display: flex;
    align-items: center;
    bottom: 40px;
    width: 85%;
    height: 50px;
    margin: 0 auto;
    border-radius: 6px;
    background: rgba(38, 38, 38, 0.9);
    z-index: 10;
    .vjs-control {
      vertical-align: middle;
    }
    .vjs-button {
      .vjs-icon-placeholder:before {
        font-size: 25px;
        padding-top: 4px;
      }
    }
    .vjs-remaining-time {
      display: none !important;
    }
    .vjs-time-control {
      display: block;
      font-size: 12px;
      padding: 8px 4px;
      color: #b2b2b2;
      min-width: 10px;
    }
    .vjs-time-control.vjs-time-divider {
      span {
        display: none;
      }
      div::before {
        content: "|";
        color: #b2b2b2;
      }
    }
    .vjs-play-control {
      order: -2;
      width: 6em;
      .vjs-icon-placeholder:before {
        font-size: 36px;
        padding-top: 0px;
        margin-top: -4px;
      }
    }
    .vjs-volume-panel {
      order: 1;
      .vjs-volume-control {
        margin-top: 10px;
      }
    }
    .vjs-live-control {
      width: 6em;
      order: 0;
    }
    .vjs-picture-in-picture-control {
      display: none;
    }
    .vjs-fullscreen-control {
      order: 1;
    }
    .vjs-play-progress {
      height: 6px;
      background: #cc373c;
    }
    .vjs-play-progress:before {
      content: "";
      width: 6px;
      height: 8px;
      top: -1px;
      background: #ff575c;
    }
    .vjs-progress-control .vjs-slider {
      margin: 20px 10px;
      height: 8px;
      border: 1px solid #666;
      padding: 0;
      width: auto;
    }
  }
}
</style>
